import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'IssueFormDescriptionController',
            IssueFormDescriptionController
        );

    function IssueFormDescriptionController() {}
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/description/issue_form_description.controller.ts